import React, {useState, useEffect} from 'react';
import {Select, notification, Button, Form, Checkbox} from 'antd';
import http from "../../Utilities/http";
import './ShippingOrderFormConfig.css';
import Heading from "../Common/Heading";
import Wrapper from "../Common/Wrapper";
import EntitySelector from "./EntitySelector";
import ApiService from "../../services/ApiService";

const {Option} = Select;
const initialPrintState = {VA4: {show: true}, VA6: {show: true}, TripleA4: {show: true}, ListOfOrdersA4: {show: true}};

function ShippingOrderSettings() {
  const [queryBy, setQueryBy] = useState('userId');
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [measurementUnits, setMeasurementUnits] = useState([]);
  const [umConfig, setUmConfig] = useState([]);
  const [printConfig, setPrintConfig] = useState(initialPrintState);
  const [_formConfig, setFormConfig] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [form] = Form.useForm();


  useEffect(() => {
    fetchStaticData();
  }, []);

  const fetchStaticData = () => {
    http.get("/measurementunit")
      .then((res) => {
        const unique = [...new Map(res.data.map(item => [item.code, item])).values()];
        setMeasurementUnits(unique);
      })
      .catch((error) => {
        setMeasurementUnits([]);
        notification.error({
          message: 'Error',
          description: 'Failed to fetch measurement units.',
        });
      });
  };


  const handleQueryByChange = (e) => {
    setQueryBy(e);
    if (e === 'default') {
      fetchConfig(null, e);
      setUmConfig([]);
      setPrintConfig(initialPrintState);
      setShowForm(true);
    } else {
      setShowForm(false);
    }
    setSelectedEntity(null);

  };


  const fetchConfig = async (entityId, queryBy) => {
    const entityType = queryBy.replace('Id', '');

    try {
      const response = await ApiService.getShippingOrderFormConfig(entityType === 'default' ? 'global' : entityType, entityId ?? '0', _formConfig)
      setUmConfig(response['allowedMeasurementUnits'] ?? []);
      const prints = response['prints'];
      setPrintConfig((prints && Object.keys(prints).length > 0)
        ? prints
        : initialPrintState);
      form.setFieldsValue((prints && Object.keys(prints).length > 0)
        ? prints
        : initialPrintState); // Set form values programmatically
      setFormConfig(response);
    } catch (error) {
      setUmConfig([])
      setPrintConfig(initialPrintState);
      setFormConfig({
        'allowedMeasurementUnits': [],
        'prints': initialPrintState
      });
    }
  };

  const handleEntitySelect = (value) => {
    setSelectedEntity(value);
    if (!!value) {
      setShowForm(true);
    }
    fetchConfig(value, queryBy);
  };

  const handleSaveConfig = async () => {
    const formValues = form.getFieldsValue();
    const entityType = queryBy.replace('Id', '');
    const fc = _formConfig;

    fc['allowedMeasurementUnits'] = umConfig.length > 0 ? umConfig : undefined;
    fc['prints'] = formValues; // Use the current values from the form

    try {
      const response = await ApiService.updateShippingOrderFormConfig(entityType === 'default' ? 'global' : entityType, selectedEntity ?? '0', fc)

      if (response.status !== 200) {
        const errorBody = await response.text();
        throw new Error(errorBody || 'Failed to save configuration.');
      }

      notification.success({
        message: 'Success',
        description: 'Επιτυχής Αποθήκευση.',
      });
    } catch (error) {
      console.error('Error saving config:', error);
      notification.error({
        message: 'Error',
        description: error.message,
      });
    }
  };

  const voucherLabels = {VA4: 'Voucher A4', VA6: 'Voucher A6', TripleA4: 'Triple Crystal Report', ListOfOrdersA4: 'List of Orders'}

  return (
    <div>
      <Heading>Γενικές Ρυθμίσεις Εντολών Μεταφοράς</Heading>
      <EntitySelector
        onEntitySelect={handleEntitySelect}
        onQueryByChange={handleQueryByChange}
        queryBy={queryBy}
        selectedEntity={selectedEntity}
      />
      {showForm && (
        <Wrapper>
          {!!printConfig && (
            <div className="config-display">
              <h2>Εκτυπώσεις</h2>
              <Form form={form} layout="vertical">
                {Object.keys(printConfig).map(key => (
                  <Form.Item name={[key, 'show']} valuePropName="checked" key={key}>
                    <Checkbox checked={printConfig[key]}>{voucherLabels[key]}</Checkbox>
                  </Form.Item>
                ))}
              </Form>
            </div>
          )}
          {umConfig && (
            <div className="config-display">
              <h2>Μονάδες Μέτρησης</h2>
              <Select
                mode="multiple"
                value={umConfig}
                onChange={setUmConfig}
                style={{width: '100%'}}
                placeholder="Select units"
              >
                {measurementUnits.map(unit => <Option key={unit.code} value={unit.code}>{unit.description}</Option>)}
              </Select>
            </div>
          )}
          <Button
            type="primary"
            onClick={handleSaveConfig}
            style={{marginTop: '10px'}}
          >
            Save
          </Button>
        </Wrapper>
      )}
    </div>
  )
}

export default ShippingOrderSettings;
